// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"71":"explorer-side","85":"explorer-core"}[chunkId] + "." + {"71":"08e06ce4","85":"1af0f8cf"}[chunkId] + ".css";
};